import { deleteLessonVersion } from "api/services/lesson-service";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";

export const useDeleteLessonVersion = () => {
    const { callAPI, loading } = useWorkspaceApiCall(
        deleteLessonVersion,
        'deleteLessonVersion.success',
        'deleteLessonVersion.error'
    );

    return {
        deleteLessonVersion: callAPI,
        deleting: loading
    };
};